export default "__VITE_ASSET__4def3408__"